import React from 'react';
import Button from 'devextreme-react/button';
import { sizes } from 'logic/media-query';

// Component styles
import classes from "./SingleCard.module.scss";

export default ({ children, onBackClicked, showBackButton }) => {

  const isMobile = !(sizes()['screen-large']) && !(sizes()['screen-medium']);

  return (
    <div className={isMobile ? classes.singleCardSmall : classes.singleCard}>
      <div className={'dx-card dx-theme-text-color'}>
        <div className={classes.header}>
          {showBackButton
            ? (
              <Button
                icon={'arrowleft'}
                stylingMode={'text'}
                onClick={onBackClicked}
              />
            ) : null
          }
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}